<template>
    <div>
        <v-progress-linear :indeterminate="true" v-if="loading"></v-progress-linear>
        <v-container v-if="!loading" my-2>
            <form @submit.prevent="update_towns" autocomplete="off">
                <v-layout row wrap>


                    <v-flex xs12 lg2 xl2 md3 sm4>
                        <v-select class="mx-1" clearable rounded filled :items="cities" v-model="towns.city_id" outlined
                            item-text="city_name" item-value="city_id" :return-object="false"
                            :label="$store.getters.lang.data.city_name">
                        </v-select>
                    </v-flex>

                    <v-flex xs12 lg2 xl2 md3 sm4>
                        <v-text-field rounded type="text" v-model="towns.town_name"
                            :label="$store.getters.lang.data.town_name" outlined class="mx-1" filled required>
                        </v-text-field>
                    </v-flex>



                    <!-- <v-flex xs12 lg2 xl2 md3 sm4>
                        <v-text-field rounded type="text" v-model="towns.town_image"
                            :label="$store.getters.lang.data.town_image" outlined class="mx-1" filled required>
                        </v-text-field>
                    </v-flex> -->



                    <v-flex xs12 lg2 xl2 md2 sm4>
                        <v-btn color="primary" x-large rounded class="mx-1" type="submit">
                            {{$store.getters.lang.data.update_btn}}</v-btn>
                    </v-flex>
                </v-layout>
            </form>
        </v-container>

        <v-snackbar v-model="snackbar.value" :color="snackbar.color">
            {{snackbar.text}}
        </v-snackbar>
    </div>
</template>

<script>
    import controller from './../../controller/towns'
    export default {
        data() {
            return {
                towns: {},
                id: '',
                loading: true,
                snackbar: {
                    value: false,
                    text: '',
                    color: ''
                },

            }
        },
        computed: {

            cities() {
                return this.$store.getters.cities
            },


        },
        methods: {
            get_towns() {
                this.loading = true
                controller.getOne(this.id).then(r => {
                    this.towns = r.data.row
                    this.loading = false
                }).catch(e => {
                    console.log(e);
                })
            },
            update_towns() {
                controller.update_towns(this.towns).then(r => {
                    if (r.data) {
                        this.snackbar = {
                            value: true,
                            text: 'Updated',
                            color: 'success'
                        }
                    } else {
                        this.snackbar = {
                            value: true,
                            text: 'Not Updated',
                            color: 'error'
                        }
                    }
                })
            },

        },
        mounted() {
            this.id = this.$route.params.id
            this.get_towns()
        },
    }
</script>